import type { PurchaseType } from '../purchases/purchase.enum'

export class PaymentLink {
    createdAt: Date
    updatedAt: Date
    paymentLinkId: string
    companyId: string
    gatewayId: string
    purchaseDescription: string
    purchaseQuantity: number
    purchaseTotalValue: number
    purchaseTotalInstallments: number
    // entrada do carnê: o primeiro vencimento vale isto e os demais dividem o que sobra
    purchaseEntryValue?: number
    paymentMethodsAllowed: string
    purchaseType: PurchaseType
    status: number
    referenceId?: string
    purchaseLaunchType?: string
    purchaseServiceId?: string
    purchaseUserId?: string
    purchasePaymentId?: string
    // O QUE se cobra (à vista × recorrente). Não confundir com adHoc, que é COMO o registro nasceu:
    // um item de catálogo também vira link quando compartilhado.
    category: 'link' | 'subscription'
    purchaseInterval: number
    // emitido para uma cobrança só. não aparece nos cadastros.
    adHoc?: boolean
    // validade, só no avulso
    expiresAt?: Date
}
